import { Button, Form, Input, Space, Row, Col } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { isValidArray } from '../../../../utils/helpers'
import styles from '../../../../testrun.module.css'

const { TextArea } = Input

function ExportReportForm(props) {
    const {
        setOpen = () => { },
        onExport = () => { },
        exporting = false,
        reportId = '',
    } = props

    const [form] = Form.useForm()

    const handleSubmit = async (values) => {
        const finalAttachments = isValidArray(values?.attachments)
            ? values?.attachments?.filter(
                (item) => item.name.trim() !== '' && item.url.trim() !== ''
            )
            : []
        const payload = {
            reportId,
            reportName: values?.name || '',
            notes: values?.note || '',
            attachments: finalAttachments,
        }
        onExport(payload)
    }

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
                initialValues={{
                    name: '',
                    note: '',
                    attachments: [{ name: '', url: '' }],
                }}
            >
                {/* Report Name */}
                <Form.Item
                    label="Report Name"
                    name="name" // <-- fixed to match payload
                    rules={[
                        { required: true, message: 'Report name is required' },
                        { max: 120, message: 'Max 120 characters' },
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <Input placeholder="Enter title" />
                </Form.Item>

                {/* Notes */}
                <Form.Item
                    label="Note"
                    name="note"
                    style={{ marginBottom: 16 }}
                >
                    <TextArea rows={4} placeholder="Enter note" />
                </Form.Item>

                <p>Attachments</p>

                {/* Attachments (Dynamic) */}
                <Form.List name="attachments">
                    {(fields, { add, remove }) => (
                        <Space
                            direction="vertical"
                            style={{ width: '100%' }}
                            size={12}
                        >
                            {fields.map(({ key, name, ...restField }, idx) => (
                                <div key={key}>
                                    <Row gutter={[12, 8]} align="top">
                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'name']}
                                                label="Name"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message:
                                                            'Please enter a name',
                                                    },
                                                    {
                                                        max: 100,
                                                        message:
                                                            'Max 100 characters',
                                                    },
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input placeholder="Name" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={14}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'url']}
                                                label="URL"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message:
                                                            'Please enter a URL',
                                                    },
                                                    {
                                                        type: 'url',
                                                        message:
                                                            'Please enter a valid URL (include http/https)',
                                                    },
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input placeholder="https://example.com" />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            xs={24}
                                            md={2}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                justifyContent: 'flex-start',
                                                gap: 8,
                                                marginTop: 30,
                                            }}
                                        >
                                            {idx > 0 && (
                                                <Button
                                                    title="Remove"
                                                    danger
                                                    type="text"
                                                    icon={
                                                        <MinusCircleOutlined />
                                                    }
                                                    onClick={() => remove(name)}
                                                    aria-label="Remove row"
                                                ></Button>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            ))}

                            <Button
                                type="link"
                                className={styles.linkButton}
                                onClick={() => add({ name: '', url: '' })}
                                icon={<PlusOutlined />}
                            >
                                Add more
                            </Button>
                        </Space>
                    )}
                </Form.List>

                {/* Actions */}
                <div className={styles.formActions}>
                    <button
                        type="button"
                        className={styles.cancelButton}
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className={`${styles.submitButton} ${
                            exporting ? styles.submitButtonDisabled : ''
                        }`}
                        disabled={exporting}
                    >
                        {exporting ? 'Exporting...' : 'Export'}
                    </button>
                </div>
            </Form>
    )
}

export default ExportReportForm
